import { forwardRef, LabelHTMLAttributes } from 'react';
import { clsx } from 'clsx';

import classNames from './styles.module.css';

export type LabelProps = LabelHTMLAttributes<HTMLLabelElement>;

export const Label = forwardRef<HTMLLabelElement, LabelProps>(({ children, className, ...attributes }, ref) => {
  return <label ref={ref} className={clsx(classNames.label, className)} {...attributes} >{children}</label>;
});